import React, { useEffect, useState } from 'react'

import { Row, Col, Card, Typography } from 'antd'
import { StarOutlined } from '@ant-design/icons'

import EmptyData from '../../../../assets/images/ico_dashboard.svg'

import './styles.css'

import { api } from '../../../../util/handlerRequestUtil'

export const EibBigNumbers = ({ filter }) => {
  const [bigNumbers, setBigNumbers] = useState({})

  useEffect(() => {
    if (filter.safra_id) {
      loadBigNumbers(filter)
    }
  }, [filter])

  async function loadBigNumbers(filter) {
    const bigNumbers = await api.getEibBignumbers(filter)
    setBigNumbers(bigNumbers)
  }

  if (bigNumbers.length > 0) {
    return (
      <Row gutter={[16, 16]} style={{ fontWeight: 'bold', fontSize: 24 }}>
        <h3 style={{ fontSize: 14, fontWeight: 500, color: '#263447' }}>Acompanhamento de ações EIB Soja</h3>
        <Col
          span={24}
          style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'center', alignItems: 'center' }}
        >
          <Card className="ant-card-bordered card" style={{ width: '30%', height: 120 }}>
            <div className="container-card">
              <div className="label-card-info">
                <h3 className="label-card-info-title">Qtd. Eleitos em Carteira</h3>
                <h1 className="label-card-info-number">{bigNumbers[0].eleitos_carteira}</h1>
              </div>
            </div>
          </Card>
          <Card className="ant-card-bordered card" style={{ width: '30%', height: 120 }}>
            <div className="container-card">
              <div className="label-card-info">
                <h3 className="label-card-info-title">Qtd. Eleitos EIB</h3>
                <h1 className="label-card-info-number" style={{ marginTop: 16 }}>
                  {bigNumbers[0].eleitos_eib}
                </h1>
              </div>
            </div>
          </Card>
          <Card className="ant-card-bordered card" style={{ width: '30%', height: 120 }}>
            <div className="container-card">
              <div className="label-card-info">
                <h3 className="label-card-info-title">Qtd. Clientes Planejados</h3>
                <h1 className="label-card-info-number">{bigNumbers[0].clientes_planejados}</h1>
              </div>
            </div>
          </Card>
        </Col>

        <Col span={24} style={{ display: 'flex', textAlign: 'center', alignItems: 'center' }}>
          <Card className="ant-card-bordered card" style={{ width: '100%', height: 120 }}>
            <Row type="flex" justify="start">
              <div className="container-card" style={{ width: '20%' }}>
                <div className="label-card-info">
                  <h3 className="label-card-info-title" style={{ fontSize: 13 }}>
                    Qtd. Eleitos Cadastrado no Impulso
                  </h3>
                  <h1 className="label-card-info-number">{bigNumbers[0].eleitos_cadastrados}</h1>
                </div>
              </div>

              <div className="linha-vertical"></div>
              <div className="container-card-medium">
                <div className="label-card-info">
                  <span style={{ fontSize: 14, color: '#BBC2CC' }}>
                    <StarOutlined /> 1
                  </span>
                  <span className="number-midlle">{bigNumbers[0].classification_1}</span>
                </div>
              </div>

              <div className="linha-vertical"></div>
              <div className="container-card-medium">
                <div className="label-card-info">
                  <span style={{ fontSize: 14, color: '#BBC2CC' }}>
                    <StarOutlined color="#BBC2CC" size={14} /> 2
                  </span>
                  <span className="number-midlle">{bigNumbers[0].classification_2}</span>
                </div>
              </div>

              <div className="linha-vertical"></div>
              <div className="container-card-medium">
                <div className="label-card-info">
                  <span style={{ fontSize: 14, color: '#BBC2CC' }}>
                    <StarOutlined color="#BBC2CC" size={14} /> 3
                  </span>
                  <span className="number-midlle">{bigNumbers[0].classification_3}</span>
                </div>
              </div>

              <div className="linha-vertical"></div>
              <div className="container-card-medium">
                <div className="label-card-info">
                  <span style={{ fontSize: 14, color: '#BBC2CC' }}>
                    <StarOutlined color="#BBC2CC" size={14} /> 4
                  </span>
                  <span className="number-midlle">{bigNumbers[0].classification_4}</span>
                </div>
              </div>

              <div className="linha-vertical"></div>
              <div className="container-card-medium">
                <div className="label-card-info">
                  <span style={{ fontSize: 14, color: '#BBC2CC' }}>
                    <StarOutlined color="#BBC2CC" size={14} /> 5
                  </span>
                  <span className="number-midlle">{bigNumbers[0].classification_5}</span>
                </div>
              </div>
            </Row>
          </Card>
        </Col>

        <Col
          span={24}
          style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'center', alignItems: 'center' }}
        >
          <Card className="ant-card-bordered card" style={{ width: '30%', height: 120 }}>
            <div className="container-card">
              <div className="label-card-info">
                <h3 className="label-card-info-title">Qtd. Ações Planejadas</h3>
                <h1 className="label-card-info-number">{bigNumbers[0].acoes_planejadas}</h1>
              </div>
            </div>
          </Card>
          <Card className="ant-card-bordered card" style={{ width: '30%', height: 120 }}>
            <div className="container-card">
              <div className="label-card-info">
                <h3 className="label-card-info-title">Qtd. Ações Executadas</h3>
                <h1 className="label-card-info-number">{bigNumbers[0].acoes_executadas}</h1>
                <p style={{ fontSize: 14, fontWeight: 500, color: '#8591A1' }}>
                  ({bigNumbers[0].acoes_executadas_porcentage}%)
                </p>
              </div>
            </div>
          </Card>
          <Card className="ant-card-bordered card" style={{ width: '30%', height: 120 }}>
            <div className="container-card">
              <div className="label-card-info">
                <h3 className="label-card-info-title">Média de Ações por Plano</h3>
                <h1 className="label-card-info-number">{bigNumbers[0].media_acoes}</h1>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    )
  } else {
    return (
      <div style={{ width: '100%' }}>
        <div style={{ display: 'grid', placeItems: 'center', padding: 14, height: '57vh', background: '#F1F3F5' }}>
          <img src={EmptyData} alt="FarmIcon" style={{ marginBottom: -30 }} />
          <Typography style={{ color: '#8591A1', fontWeight: 'bold', textAlign: 'center', fontSize: 18 }}>
            {'Sem dados'}
          </Typography>
          <Typography
            style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18, marginTop: -50 }}
          >
            {'Aplique ou altere o filtro para'}
          </Typography>
          <Typography
            style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18, marginTop: -120 }}
          >
            {'exibir dados.'}
          </Typography>
        </div>
      </div>
    )
  }
}
